// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__268Hd","signatureButtonsRight":"ModalSign_signatureButtonsRight__3HXJk"};